export class ScreenSizeObserver {
    private windowResizeObserver: ResizeObserver | null = null;
    private windowDotNetRef: any = null;

    observeWindowSize(dotNetObjectRef: any) {
        this.windowDotNetRef = dotNetObjectRef;
        if (this.windowResizeObserver) return;
        this.windowResizeObserver = new ResizeObserver(() => {
            if (!this.windowDotNetRef) return;
            this.windowDotNetRef.invokeMethodAsync('OnElementSizeChanged', window.innerWidth, window.innerHeight);
        });
        this.windowResizeObserver.observe(document.body);
    }

    getWindowSizeInfo() {
        return {
            width: window.innerWidth,
            height: window.innerHeight
        };
    }

    disposeWindowSizeObserver() {
        if (this.windowResizeObserver) {
            this.windowResizeObserver.disconnect();
            this.windowResizeObserver = null;
        }
        this.windowDotNetRef = null;
    }
}

(window as any).createScreenSizeObserver = function(dotNetObjectRef:any) {
    const observer = new ScreenSizeObserver();
    observer.observeWindowSize(dotNetObjectRef);
    return observer;
}